import React from 'react';
import PropTypes from 'prop-types';

import LocationSwitcher from './LocationSwitcher';
import CityBrowseHeaderImage from './CityBrowseHeaderImage';
import { EXPERIMENTS_SHAPE_PROP_TYPE } from '../constants';

import './cityBrowseHeader.scss';

const CityBlurb = ({ cityBlurb }) => {
    let component = null;

    if (cityBlurb) {
        component = (
            // using dangerouslySetInnerHtml because data from wagtail is written in HTML
            <div
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: cityBlurb }}
                className="eds-text-bm eds-l-mar-vert-4 spaced-paragraphs"
                data-spec="city-blurb"
            />
        );
    }

    return component;
};

export default class CityBrowseHeader extends React.Component {
    static propTypes = {
        currentPlace: PropTypes.string,
        cityBlurb: PropTypes.string,
        cityImage: PropTypes.string,
        citySmallImage: PropTypes.string,
        handleLocationSuggestionChange: PropTypes.func,
        shouldHideMask: PropTypes.bool,
        experiments: EXPERIMENTS_SHAPE_PROP_TYPE,
        handleUseCurrentLocation: PropTypes.func,
        handleLocationSelect: PropTypes.func,
        h1: PropTypes.string,
    };

    state = {
        isMounted: false,
    };

    componentDidMount() {
        this.setState({ isMounted: true });
    }

    render() {
        const {
            cityBlurb,
            cityImage,
            citySmallImage,
            handleLocationSuggestionChange,
            shouldHideMask,
            experiments,
            currentPlace,
            handleUseCurrentLocation,
            handleLocationSelect,
            h1Prefix,
            isOnline,
            history,
        } = this.props;
        const currentPlaceSplitted = currentPlace.split(',')[0];

        return (
            <header className="city-browse-header">
                <div className="city-browse-header__main eds-g-cell eds-g-cell-1-1 eds-g-cell-mn-4-12">
                    <LocationSwitcher
                        handleLocationSuggestionChange={
                            handleLocationSuggestionChange
                        }
                        currentPlace={currentPlace}
                        handleUseCurrentLocation={handleUseCurrentLocation}
                        handleLocationSelect={handleLocationSelect}
                        isOnline={isOnline}
                        history={history}
                    />
                    {// Deal with issue where this will briefly appear during the desktop load
                    this.state.isMounted && (
                        <div className="city-browse-header__aside city-browse-header__aside--small eds-g-cell eds-g-cell-1-1 eds-l-mar-top-2 eds-l-mar-bot-10">
                            <CityBrowseHeaderImage
                                currentPlace={currentPlace}
                                cityImage={cityImage}
                                citySmallImage={citySmallImage}
                                shouldHideMask={shouldHideMask}
                                experiments={experiments}
                            />
                        </div>
                    )}
                    <div className="city-browse-header__main__content eds-align--center-vertical">
                        <div className="eds-g-cell eds-g-cell-1-1 eds-g-offset-mn-1-12 eds-l-pad-hor-4">
                            <h1 className="eds-text-bm eds-l-mar-bot-4">
                                {h1Prefix}{' '}
                                <span className="eds-text-hl city-browse-header__city-name-text">
                                    {currentPlaceSplitted}
                                </span>
                            </h1>
                            <CityBlurb cityBlurb={cityBlurb} />
                        </div>
                    </div>
                </div>

                <aside className="city-browse-header__aside city-browse-header__aside--large eds-g-cell eds-g-cell-7-12 eds-g-offset-1-12 eds-l-mn-pad-left-2">
                    <CityBrowseHeaderImage
                        currentPlace={currentPlace}
                        cityImage={cityImage}
                        citySmallImage={citySmallImage}
                        shouldHideMask={shouldHideMask}
                        experiments={experiments}
                    />
                </aside>
            </header>
        );
    }
}
